module.exports = __webpack_public_path__ + "static/media/hwe_logo.96479621.svg";